












import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Tabbar, TabbarItem } from 'vant';

Vue.use(Tabbar).use(TabbarItem);

@Component
export default class BottomTabbar extends Vue {
  @Prop() tabs!: [{ tabName: string; tabPath: string }];
  active = 0;
  @Watch('$route', {
    immediate: true,
  })
  onRouteChange(to: any) {
    for (let i = 0; i < this.tabs.length; i++) {
      if (this.tabs[i].tabPath === to.path) {
        this.active = i;
      }
    }
  }

  navTo(index: number) {
    console.log('前往页面' + index);
    this.$router.push(this.tabs[index].tabPath);
  }
}
